import type { Schemas } from "#shopware"

// GET routes that don't decode Shopware's compressed `_criteria` param (e.g. /store-api/layout-cms)
// still read plain `includes[entity][]=field` query params - but ofetch's query serializer can't
// encode a nested object into that shape, so this flattens Includes into keys it can.
export function toIncludesQueryParams(includes: Schemas["Includes"]): Record<string, string[]> {
    return Object.fromEntries(
        Object.entries(includes).map(([entity, fields]) => [`includes[${entity}][]`, fields]),
    )
}
